/* eslint linebreak-style: ["error", "unix"] */
import Modal from 'components/modals/modal/modal';
import CloseButtonWhite from 'components/buttons/button-close/close-button.white';
import { ModalQueryParams } from 'data/app';
import DataRenderer from 'components/data-renderer/data-renderer';
import SectionTitle from 'components/section-title/section-title';
import { useModalStyles } from 'styles/modal.styles';
import useModalQueryWithId from 'hooks/useModalQueryWithId';
import { DocumentCategory, getDocumentCategoryByIdGql } from 'data/document-categories';
import FormDocumentCategory from 'components/forms/form-document-category/form-document-category';

export default function ModalEditDocumentCategory() {
  const classes = useModalStyles();

  const {
    data, loading, errorMessage, isOpen, handleClose,
  } = useModalQueryWithId<DocumentCategory>(
    ModalQueryParams.EDIT_DOCUMENT_CATEGORY,
    getDocumentCategoryByIdGql,
    'getDocumentCategoryById',
  );

  return (
    <Modal
      className={classes.modal}
      open={isOpen}
      onClose={handleClose}
      closeButtonComponent={CloseButtonWhite}
      hasCloseButton
    >
      <DataRenderer loading={loading} error={errorMessage}>
        <SectionTitle>Editar categoria de documento</SectionTitle>
        <FormDocumentCategory
          data={data}
          onSuccess={handleClose}
        />
      </DataRenderer>
    </Modal>
  );
}
